import { useState } from "react";
import { auth, db } from "./firebase";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  updateProfile,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [error, setError] = useState("");
  const [showNamePrompt, setShowNamePrompt] = useState(false);
  const [fullName, setFullName] = useState("");
  const [tempUser, setTempUser] = useState(null);

  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      setTempUser(userCredential.user);
      setShowNamePrompt(true);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleNameSubmit = async () => {
    if (!fullName.trim()) {
      alert("Please enter your full name.");
      return;
    }

    try {
      const user = tempUser;
      const name = fullName.trim();

      // 1️⃣ Set display name
      await updateProfile(user, { displayName: name });

      // 2️⃣ Generate referral code ONCE
      const generatedReferralCode = uuidv4().slice(0, 8).toUpperCase();

      const userRef = doc(db, "users", user.uid);

      // 3️⃣ Create user document (single authoritative write)
      await setDoc(userRef, {
        profile: {
          email: user.email,
          name,
          referralCode: generatedReferralCode,
          volunteerHours: 0,
          createdAt: new Date(),
        },
      });

      // 4️⃣ Apply referral via Cloud Function (non-blocking)
      if (referralCode.trim()) {
        const functions = getFunctions();
        const applyReferral = httpsCallable(functions, "applyReferral");
        try {
          await applyReferral({ referralCode: referralCode.trim() });
        } catch (err) {
          console.warn("Referral failed (ignored):", err.message);
        }
      }

      // 5️⃣ Send verification email
      await sendEmailVerification(user, {
        url: window.location.origin + "/Login",
      });

      // 6️⃣ Force logout (required by your auth model)
      await auth.signOut();

      alert("✅ Verification email sent! Please verify before logging in.");
      setShowNamePrompt(false);
      navigate("/Login");
    } catch (err) {
      setError(err.message);
    }
  };

  // const handleGoogleRegister = async () => {
  //   try {
  //     const provider = new GoogleAuthProvider();
  //     const result = await signInWithPopup(auth, provider);
  //     const user = result.user;

  //     // Google users are auto-verified
  //     await setDoc(doc(db, "users", user.uid), {
  //       profile: {
  //         email: user.email,
  //         name: user.displayName,
  //         referralCode: uuidv4().slice(0, 8).toUpperCase(),
  //         volunteerHours: 0,
  //         createdAt: new Date(),
  //       },
  //     });

  //     navigate("/VolunteerHours");
  //   } catch (err) {
  //     setError(err.message);
  //   }
  // };

  return (
    <div className="login-container">
      <div className="login-left">
        <h1 className="signup-heading">Sign Up</h1>
        <p>Enter your details to create your account.</p>

        {error && <p className="error">{error}</p>}

        <form onSubmit={handleRegister}>
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <label>Referral Code (optional)</label>
          <input
            type="reg"
            value={referralCode}
            onChange={(e) => setReferralCode(e.target.value.toUpperCase())}
          />

          <button type="submit" className="login-btn">
            Register
          </button>
        </form>

        {/* <div className="divider"></div>
        <button
          type="button"
          className="google-btn"
          onClick={handleGoogleRegister}
        >
          Sign up with Google
        </button> */}
      </div>

      <div className="login-right">
        <div className="overlay-text">
          <h2>Welcome to Echelon</h2>
          <p>Please verify your email after signing up to activate your account.</p>
        </div>
      </div>

      {showNamePrompt && (
        <div className="login-popup-overlay">
          <div className="login-popup">
            <h2>Almost there!</h2>
            <p>Please enter your full name to complete your registration.</p>
            <input
              type="text"
              placeholder="Full Name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                marginBottom: "20px",
                fontSize: "16px",
              }}
            />
            <button
              className="login-redirect-btn"
              onClick={handleNameSubmit}
            >
              Continue
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Register;
